module.exports = __webpack_public_path__ + "static/media/_MIC2383.thumbnail.75746182.png";